import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

/** Results per request, as in the old typeaheads. */
const PAGE_SIZE = 20;
/** The old typeaheads didn't search until this many characters were typed. */
const MIN_SEARCH_LENGTH = 2;

interface SearchDataSourceOptions<T> {
    /** The item field DropDownBox's value refers to. */
    key: string;
    /** One page of results for the (lowercased) search text; page starts at 1. */
    search: (searchText: string, page: number, pageSize: number) => Promise<T[]>;
    /** The selected item, so the box can show it before anything is searched. */
    getByKey: (id: number) => Promise<T>;
}

/**
 * A DropDownBox dataSource that searches the server as the user types, a page at a time as they scroll, in place of the
 * old react-bootstrap-typeahead pickers.
 */
export const createSearchDataSource = <T>({ key, search, getByKey }: SearchDataSourceOptions<T>) =>
    new DataSource({
        store: new CustomStore({
            key,
            load: (options) => {
                const searchText = String(options.searchValue ?? '').toLowerCase();
                if (searchText.length < MIN_SEARCH_LENGTH) {
                    return Promise.resolve([]);
                }
                const page = Math.floor((options.skip ?? 0) / PAGE_SIZE) + 1;
                return search(searchText, page, PAGE_SIZE);
            },
            byKey: getByKey,
        }),
        paginate: true,
        pageSize: PAGE_SIZE,
    });
